<template>
  <div>
    <div class="login-box" v-if="!isOtherLogin">
      <div class="logo-img" v-if="type === '鹿城'" style="margin-top: 50px;">
        <img src="@/assets/img/lc-logo02.png" style="margin-bottom: 40px;" />
        <p>鹿城停车岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '龙港'" style="margin-top: 50px;">
        <img src="@/assets/img/lg-logo02.png" style="width: 42px;"/>
        <p>龙港交发岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '停简单'" style="margin-top: 50px;">
        <img src="@/assets/img/wz-logo02.png" style="width: 42px;" />
        <p>停简单岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '数发'" style="margin-top: 50px;">
        <img src="@/assets/img/sf-logo02.png" style="width: 42px;" />
        <p>数发停车岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '上饶'" style="margin-top: 50px;">
        <img src="@/assets/img/sr-logo02.png" style="width: 42px;" />
        <p>上饶畅通岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '武汉'" style="margin-top: 50px;">
        <img src="@/assets/img/wh-logo02.png" style="margin-bottom: 40px; width: 42px;" />
        <p>武汉城停岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '萍乡'" style="margin-top: 50px;">
        <img src="@/assets/img/px-logo02.png" style="margin-bottom: 40px; width: 42px;" />
        <p>萍乡停车岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '逐一'">
        <img src="@/assets/img/zy-logo02.png" style="margin-bottom: 40px; width: 42px;" />
        <p>智慧停车岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '车都'" style="margin-top: 50px;">
        <img src="@/assets/img/cd-logo02.png" style="margin-bottom: 40px;" />
        <p>车都停车岗亭系统</p>
      </div>
      <div class="logo-img" v-else-if="type === '温州'" style="margin-top: 50px;">
        <img src="@/assets/img/logo02.png" style="margin-bottom: 40px;" />
        <p>智慧停车系统岗亭端</p>
      </div>
      <div class="logo-img" v-else>
        <img src="@/assets/img/logo02.png" style="width: 42px;"/>
        <p>智慧停车岗亭系统</p>
      </div>
      <div class="login-form">
        <el-input
          v-model.trim="loginForm.username"
          class="login-input"
          type="text"
          name="username"
          autocomplete="on"
          prefix-icon="el-icon-user"
          placeholder="请输入账号"
        />
        <el-input
          v-model.trim="loginForm.password"
          class="login-input"
          type="password"
          name="password"
          prefix-icon="el-icon-unlock"
          placeholder="请输入密码"
          @keyup.enter="handleLogin"
        />
        <div class="err-msg">
          {{ showErrorInfo }}
        </div>
<!--        <Vcode :show="isShowVcode" @success="onSuccess" @close="isShowVcode = false" />-->
        <div class="login-btn" @click="handleLogin">登录</div>
      </div>
    </div>
    <div class="other-login" v-else>
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
// import { isvalidUsername } from "@/utils/validate";
// import { reg, checkReg } from "@/utils/RegExp";
import { distinguishTitle, getUrlParam, handleAssign } from "@/utils/index";
import { toLogin } from "@/api/module/login";
import { setToken, setRoleCode, setUserId, setTenantId } from "@/utils/service";
import cryptoAES from "@/utils/cryptoAES.js";
// import Vcode from "vue-puzzle-vcode";

export default {
  components: {
    // Vcode
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      showErrorInfo: "",
      baseURL: { baseURL: "http://xx.xxx.com" },
      plateStr: "",
      type: null,
      isOtherLogin: false,
      isShowVcode: false,
    };
  },
  mounted() {
    this.type = distinguishTitle();
    let param = getUrlParam(window.location.href);
    this.isOtherLogin = JSON.stringify(param) !== '{}';
    if (this.isOtherLogin) {
      let str = JSON.parse(cryptoAES.decrypt(param.key));
      let obj = JSON.parse(str);
      this.loginForm.username = obj.Account;
      this.loginForm.password = obj.Password;
      this.handleLogin();
    }

    // console.log(this.type)
  },
  methods: {
    async handleLogin() {
      if (this.loginForm.username === "" || this.loginForm.password === "") {
        this.showErrorInfo = "用户名和密码不能为空!";
        return false;
      }
      // if (!isvalidUsername(this.loginForm.username)) {
      //   this.showErrorInfo = "用户名格式错误!";
      //   return false;
      // }
      // if (!checkReg(reg["password"], this.loginForm.password)) {
      //   this.showErrorInfo = "密码长度6~16,至少一个数字和字母,区分大小写!";
      //   return false;
      // }
      this.showErrorInfo = "";
      let res = await toLogin({
        Account: cryptoAES.encrypt(this.loginForm.username),
        Password: cryptoAES.encrypt(this.loginForm.password),
        LoginPlatform: 'gate',
      });
      // console.log('登录结果',res)
      if (res.state === "success") {
        let data = res.data;
        setToken(data.Token);
        setUserId(data.Id);
        setTenantId(data.TenantId);
        this.$store.dispatch("SetUserInfo", data);
        this.$store.dispatch("SetUserName", data.Account);
        this.$store.dispatch("SetIsCashier", data.Role.RoleCode);
        setRoleCode(data.Role.RoleCode);
        this.$store.dispatch("SetIsSentryBoxTabs", String(data.Role.RoleCode === 'sentryBoxManager' || data.Role.RoleCode === 'sentryBox' && data.UserGateType === 2));
        if (this.isOtherLogin) {
          handleAssign("/home/tenant/");
        } else {
          this.$router.push("/home/tenant/");
        }
      } else {
        this.showErrorInfo = res.message;
      }
    },
    onSuccess() {
      this.isShowVcode = false;
      this.handleLogin();
    },
  },
};
</script>

<style lang="scss" scoped>
.login-box {
  overflow: hidden;
  width: 542px;
  height: 610px;
  background: #ffffff;
  box-shadow: 0px 10px 60px #2a4897;
  opacity: 1;
  border-radius: 16px;
  font-size: 16px;
  position: fixed;
  right: 16%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  text-align: center;
  .logo-img {
    width: 240px;
    margin: 40px auto;
    // height: 89px;
    // background: url("../../../assets/img/login_logo.png") no-repeat;
    // background-size: 100% 100%;
    & img {
      margin-top: 0;
      margin-bottom: 10px;
    }
    & p {
      width: 240px;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 28px;
      color: #333333;
      opacity: 1;
    }
  }
  .err-msg {
    font-size: 14px;
    color: #fe0000;
    width: 320px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .login-btn {
    width: 320px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #0178ec;
    border-radius: 50px;
    color: #fff;
    margin: 0 auto 0;
    user-select: none;
    &:hover {
      cursor: pointer;
    }
  }
}
  .other-login{
    width: 100px;
    height: 100px;
    position: fixed;
    right: calc(50% - 50px);
    top: 50%;
    i{
      font-size: 48px;
      color: #fff;
    }
  }
</style>
<style lang="scss">
.login-input {
  width: 312px;
  height: 40px;
  line-height: 40px;
  border: none;
  outline: none;
  color: #222;
  margin-bottom: 40px;
  .el-input__inner {
    border: 0;
    border-bottom: 1px solid #eee;
  }
  &:focus {
    border-bottom: 1px solid #0178ec;
  }
  &::-webkit-input-placeholder {
    color: #ccc;
    font-size: 14px;
  }
}
/*********************************************/
.login-box{
  background: transparent!important;
  border-radius: 0!important;
  box-shadow: none!important;
  .logo-img{
    display: flex;
    width: auto!important;
    margin: 0 0 12px 0!important;
    align-items: center!important;
    img{
      width: 64px;
      /*height: 49px;*/
      margin-bottom: 0!important;
      margin-right: 14px;
    }
    p{
      width: auto!important;
      height: auto!important;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500!important;
      color: #FFFFFF!important;
      line-height: 30px!important;
    }
  }
  .login-form{
    padding-top: 110px;
    padding-bottom: 80px;
    background: #fff;
  }
  .el-input__icon{
    font-size: 20px;
  }
  .login-input{
    margin-bottom: 20px!important;
  }
  .login-btn{
    height: 44px!important;
    line-height: 44px!important;
    border-radius: 0!important;
    background: linear-gradient(90deg, #028BFA 0%, #253BF8 100%)!important;
    margin-top: 50px!important;
  }
}
</style>
